<template>
    <div class="d-flex flex-column p-2 border border-bottom-0">
        <b-button 
            block 
            disabled 
            class="border-0" 
            style="border-bottom-right-radius:0; border-bottom-left-radius:0"
            v-b-popover.hover.topleft="'Namen werden erst geteilt, wenn man auf eine Anfrage antwortet.'" 
        >
        <span v-if="value.teilnehmer.firstName">{{ value.teilnehmer.firstName }} {{ value.teilnehmer.lastName }}</span>
        <span v-else v-b-popover.hover.bottomleft="'Namen werden erst geteilt, wenn man auf eine Anfrage antwortet.'">Name nicht verfügbar</span>
        </b-button>
        <b-input-group>
            <b-form-textarea 
                ref="adresse" 
                :style="value.teilnehmer.handy ? 
                    'border-top-right-radius:0; border-top-left-radius:0;border-bottom-right-radius:0; border-bottom-left-radius:0' : 
                    'border-top-right-radius:0; border-top-left-radius:0'" 
                :value="adresseString" 
                readonly 
            />
            <template v-slot:append>
                <b-button 
                    v-b-popover.hover.topleft="'Zeigt die Adresse auf der Karte'" 
                    @click="$router.push({ name: 'Suchen', params: { mapUser: value.teilnehmer }})
                ">
                    <img src="../assets/interface/compass.svg" 
                        class="mt-n2 mx-n1" 
                        style="filter:invert(1);height:1.7em" 
                    />
                </b-button>
                <b-button 
                    v-b-popover.hover.topleft="'Kopiert die Adresse in die Zwischenablage'" 
                    @click="copyAdresse" 
                    :style="value.teilnehmer.handy ? 
                        'border-top-right-radius:0; border-top-left-radius:0; border-bottom-right-radius:0; border-bottom-left-radius:0' : 
                        'border-top-right-radius:0; border-top-left-radius:0'"
                >
                    <img src="../assets/interface/clipboard.svg" 
                        class="mt-n2 mx-n1" 
                        style="filter:invert(1);height:1.7em" 
                    />
                </b-button>
            </template>
        </b-input-group>
        <b-input-group v-if="value.teilnehmer.handy">
            <template 
                v-slot:prepend  
                style="border-top-right-radius:0; border-top-left-radius:0"
            >
                <b-form-input 
                    value='Handy:' 
                    readonly 
                    class="border-top-0 border-right-0" 
                    style="border-top-right-radius:0; border-top-left-radius:0; border-bottom-right-radius:0; width: 4.6em"
                />
            </template>
            <b-form-input 
                type="tel" 
                ref="handy" 
                class="border-top-0" 
                :value="value.teilnehmer.handy" 
                readonly 
            />
            <template v-slot:append>
                <b-button 
                    class="border-top-0" 
                    style="border-top-right-radius:0; border-top-left-radius:0" 
                    v-b-popover.hover.topleft="'Kopiert die Handynummer in die Zwischenablage'" 
                    @click="copyHandy"
                >
                    <img src="../assets/interface/clipboard.svg" 
                        class="mt-n2 mx-n1" 
                        style="filter:invert(1);height:1.7em" 
                    />
                </b-button>
            </template>
        </b-input-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setAlert } from '../tools'
import { BInputGroup, BFormInput, VBPopover } from "bootstrap-vue"
export default {
    name: "AnfragenAnzeigeInfoAdressBox",
    components:{
        BInputGroup,
        BFormInput
    },
    directives:{
        'b-popover': VBPopover
    },
    props: {
        value: undefined
    },
    computed: {
        ...mapGetters(['user']),
        adresseString: function(){
            var adressString = ''

            if(!this.value.teilnehmer.adresse.strasse)
                adressString += this.value.teilnehmer.adresse.plz + ' ' + this.value.teilnehmer.adresse.ort
            else
                adressString += this.value.teilnehmer.adresse.strasse + 
                ( !this.value.teilnehmer.adresse.hausnummer ? '\n' : ' ' + this.value.teilnehmer.adresse.hausnummer + '\n' ) + 
                this.value.teilnehmer.adresse.plz + ' ' + this.value.teilnehmer.adresse.ort

            return adressString
        }
    },
    methods: {
        copyHandy() {
            this.$refs.handy.select()
            this.$refs.handy.setSelectionRange(0, 99999)
            document.execCommand('copy')
            setAlert(this, 'Handynummer erfolgreich kopiert.', 'Kopiert', 'success')
        },
        copyAdresse() {
            this.$refs.adresse.select()
            this.$refs.adresse.setSelectionRange(0, 99999)
            document.execCommand('copy')
            setAlert(this, 'Adresse erfolgreich kopiert.', 'Kopiert', 'success')
        }
    }
}
</script>